export default "__VITE_ASSET__BXAyxB1d__"